import React from 'react'
import { Segment, Icon, Header, Divider } from 'semantic-ui-react'

import SrciWallet from './wallets/SrciWallet'
import GooglePayWallet from './wallets/GooglePayWallet'
import ApplePayWallet from './wallets/ApplePayWallet'


export default function Payment() {
  return(
    <Segment placeholder>
      <Header icon>
        <Icon name='money bill alternate outline' />
        Click on payment method below to complete payment process
      </Header>

      <Divider hidden/>

      <Segment basic textAlign='center'>      
        <SrciWallet />
        <ApplePayWallet/>
        <GooglePayWallet />
      </Segment>

    </Segment>
  )
}